// extracted by mini-css-extract-plugin
export var footerStyle = "footer-module--footerStyle--pYd6o";
export var logos = "footer-module--logos--n0E9x";
export var blurb = "footer-module--blurb--3qpQw";
export var copyright = "footer-module--copyright--NzlVR";